import { PortalMetadata } from '../models/';
import { useDocument } from './useDocument';

export function usePortalMetadata() {
  return useDocument<PortalMetadata>('PortalMetadata', 'portal_metadata');
}

export default usePortalMetadata;
